import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={{
      display: "flex", minHeight: "100vh",
      fontFamily: "'Inter', system-ui, sans-serif",
    }}>
      {/* Panel izquierdo */}
      <div style={{
        flex: "0 0 48%",
        background: "linear-gradient(145deg, #0F1629 0%, #1A2347 50%, #1E3A8A 100%)",
        display: "flex", flexDirection: "column", padding: "48px 56px",
        position: "relative", overflow: "hidden",
      }}
        className="tn-auth-left"
      >
        <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.07 }} xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="diag404" x="0" y="0" width="120" height="120" patternUnits="userSpaceOnUse" patternTransform="rotate(25)">
              <line x1="0" y1="0" x2="0" y2="120" stroke="white" strokeWidth="1"/>
              <line x1="40" y1="0" x2="40" y2="120" stroke="white" strokeWidth="1"/>
              <line x1="80" y1="0" x2="80" y2="120" stroke="white" strokeWidth="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#diag404)" />
        </svg>

        <div style={{ position: "relative", zIndex: 1, marginBottom: "auto" }}>
          <svg width="56" height="56" viewBox="0 0 64 64" fill="none" style={{ marginBottom: "40px" }}>
            <line x1="32" y1="4" x2="32" y2="60" stroke="white" strokeWidth="7" strokeLinecap="round"/>
            <line x1="4" y1="32" x2="60" y2="32" stroke="white" strokeWidth="7" strokeLinecap="round"/>
            <line x1="11" y1="11" x2="53" y2="53" stroke="white" strokeWidth="7" strokeLinecap="round"/>
            <line x1="53" y1="11" x2="11" y2="53" stroke="white" strokeWidth="7" strokeLinecap="round"/>
          </svg>

          <p style={{ fontSize: "80px", fontWeight: "800", color: "rgba(255,255,255,0.08)", lineHeight: 1, margin: "0 0 8px", letterSpacing: "-4px" }}>
            404
          </p>
          <h2 style={{ fontSize: "clamp(28px, 3vw, 42px)", fontWeight: "800", color: "#FFFFFF", lineHeight: "1.1", letterSpacing: "-1px", margin: "0 0 16px", fontStyle: "italic" }}>
            Página no<br />
            <span style={{ color: "#FF7A00" }}>encontrada.</span>
          </h2>
          <p style={{ fontSize: "15px", color: "rgba(255,255,255,0.5)", lineHeight: "1.7", maxWidth: "280px", margin: 0 }}>
            La ruta que buscas no existe o fue movida a otra ubicación.
          </p>
        </div>

        <p style={{ position: "relative", zIndex: 1, fontSize: "12px", color: "rgba(255,255,255,0.25)", margin: 0, marginTop: "48px" }}>
          © 2026 Turnora. Todos los derechos reservados.
        </p>
      </div>

      {/* Panel derecho */}
      <div style={{
        flex: 1, background: "#FFFFFF",
        display: "flex", flexDirection: "column",
        alignItems: "flex-start", justifyContent: "center",
        padding: "40px 56px",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "80px", alignSelf: "flex-start" }}>
          <div style={{
            width: "32px", height: "32px", background: "#FF7A00", borderRadius: "8px",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontWeight: "800", fontSize: "16px", color: "white"
          }}>T</div>
          <span style={{ fontSize: "16px", fontWeight: "700", color: "#0F172A", letterSpacing: "-0.3px" }}>Turnora</span>
        </div>

        <div style={{ maxWidth: "360px" }}>
          <div style={{
            width: "64px", height: "64px", borderRadius: "16px",
            background: "#FFF7ED", display: "flex", alignItems: "center",
            justifyContent: "center", marginBottom: "24px", fontSize: "32px"
          }}>🔍</div>

          <h1 style={{ fontSize: "32px", fontWeight: "800", color: "#0F172A", margin: "0 0 12px", letterSpacing: "-1px" }}>
            Vaya, esto no existe
          </h1>
          <p style={{ fontSize: "15px", color: "#64748B", margin: "0 0 36px", lineHeight: "1.6" }}>
            No pudimos encontrar lo que buscabas. Puede que la URL esté mal escrita o que la página haya sido eliminada.
          </p>

          <Link to="/" style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            height: "52px", padding: "0 32px",
            background: "#0F172A", color: "white",
            border: "none", borderRadius: "10px",
            fontSize: "15px", fontWeight: "700",
            textDecoration: "none", letterSpacing: "-0.2px",
            transition: "background 0.15s"
          }}
            onMouseEnter={(e) => e.currentTarget.style.background = "#1E2947"}
            onMouseLeave={(e) => e.currentTarget.style.background = "#0F172A"}
          >
            Volver al inicio
          </Link>
        </div>
      </div>

      <style>{`
        @media (max-width: 860px) { .tn-auth-left { display: none !important; } }
      `}</style>
    </div>
  );
}
